import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import { TextFieldRow, TextField } from 'components';
import { stateOptions } from 'helpers';
import { getAddressStateCode } from './addressState';

export default function addressMapper(
	array,
	onChange,
	classes = {},
	enterSubmit
) {
	return array.map((val) => {
		const { value, name, type, label, required, disabled } = val;
		return (
            <React.Fragment key={name}>
                {type === 'select' ? (
					<TextFieldRow label={label} required={required}>
						<Autocomplete
							options={stateOptions}
							required={required}
							getOptionLabel={(option) => option.state || ''}
							onChange={(_e, value) => {
								onChange({
									target: { name: 'state', value: getAddressStateCode(value) },
								});
							}}
							value={value}
							name={name}
							isOptionEqualToValue={(option, value) =>
								option.value === value.value
							}
							autoComplete
							autoHighlight
							autoSelect
							renderInput={(params) => (
								<>
									<TextField
										{...params}
										className={classes.inputField}
										variant='outlined'
									/>
								</>
							)}
						/>
					</TextFieldRow>
				) : (
					<TextFieldRow
						className={classes.inputField}
						required={required}
						disabled={disabled}
						onKeyDown={(e) =>
							type === 'submit' && !!enterSubmit && enterSubmit(e)
						}
						variant='outlined'
						onChange={onChange}
						value={value}
						name={name}
						label={label}
					/>
				)}
            </React.Fragment>
        );
	});
}
